export default "__VITE_ASSET__00b5414e__"